
import Vue from "vue";
import { FormsAndSurveyServices } from "@/services";
import config from "@/config";
import { emitter, NotificationType } from "@/composables/emitter";
export default Vue.extend({
  data() {
    return {
      forms: [] as { _id: string, name: string}[],
      formId: "",
      thumbnailFile: undefined as any,
      themeName: "",
    };
  },
  computed: {
    validAddTheme(): boolean {
      return this.themeName && this.formId && this.thumbnailFile ? true : false;
    },
  },
  methods: {
    async getAllThemeForms() {
      try {
        const allForms = await FormsAndSurveyServices.getAllFormsForThemes({
          locationId: config.themeLocation,
          limit: 50
        });
        this.forms = allForms.data.forms;
      } catch (error) {
        console.error(error);
      }
    },
    async addFormThemes() {
      try {
        const bodyThemeData = new FormData();
        bodyThemeData.append("themeName", this.themeName);
        bodyThemeData.append("thumbnail", this.thumbnailFile);
        bodyThemeData.append("formId", this.formId);
        const result = await FormsAndSurveyServices.createThemes(bodyThemeData);
        if (result.status === 201) {
          this.resetInput()
        }
      } catch (error: any) {
        console.error(error);
        const data = this.$refs.thumbnailUpload as HTMLInputElement;
        data.value  = '';
        emitter.$emit("notification", {
          title: "Add Failed",
          message: error.response?.data?.message || error,
          type: NotificationType.ERROR,
        });
      }
    },
    readThumbnailChange(e: any) {
      const element = <HTMLInputElement>e.target;
      if (!element.files) return;
      this.thumbnailFile = element.files[0];
    },
    resetInput(){
      this.themeName = "";
      this.formId = "";
      this.thumbnailFile = undefined;
      const data = this.$refs.thumbnailUpload as HTMLInputElement;
      data.value  = '';
    }
  },
  async mounted() {
    await this.getAllThemeForms();
  },
});
